<script setup lang="ts">
import LanguageSelector from '@/components/LanguageSelector.vue';
import urls from '@/router/urls';
import { useConfigStore } from '@gms/stores/src/stores/config';

const configStore = useConfigStore();
</script>
<template>
    <v-row class="ma-0 page-container" style="height: 100vh" no-gutters>
      <v-col
        class="page-content"
        md="4"
      >
        <div class="legal-entity">
            <div style="position:absolute; top: 2.125rem;">
                <LanguageSelector/>
            </div>
            <div class="legal-entity-logo" style="align-self: center;">
              <v-img
                src="@/assets/Audi_Rings_bl-RGB.svg"
              />
            </div>
            <div class="legal-entity-name">
              <span style="color: #f50537; margin-right: 6px">Audi</span>
              <span style="color: black">charging hub</span>
            </div>
          </div>
        <div class="content">
          <slot></slot>
        </div>
        <v-spacer/>
        <v-footer
            style="margin-top: 2rem;"
            color="black"
            dark
            width="100%"
            v-if="$vuetify.breakpoint.smAndDown"
        >
          <v-row
            no-gutters
            class="ma-0"
            justify="end"
            align="center"
            :dense="!$vuetify.breakpoint.mdAndUp"
          >
            <v-col cols="12" md="auto">
                <a
                href="https://www.green-mobility-solutions.de/impressum/"
                target="_blank"
                rel="noopener noreferrer"
                >
                {{ $t('Imprint') }}
                </a>
            </v-col>
            <v-col cols="12" md="auto">
                <a
                :href="urls.TERMS_OF_SERVICE"
                target="_blank"
                >
                {{ $t('Terms of Service') }}
                </a>
            </v-col>
            <v-col cols="12" md="auto">
                <a
                :href="urls.PRIVACY_POLICY"
                target="_blank"
                >
                {{ $t('Privacy Policy') }}
                </a>
            </v-col>
            <v-col
              class="mt-6"
            >
                {{ configStore.version }}
                <a
                href="https://book-n-use.com/"
                target="_blank"
                rel="noopener noreferrer"
                class="d-inline-flex align-center"
                >
                <span style="font-size: 11px">powered by</span>
                <v-img
                    :aspect-ratio="353/71"
                    contain
                    src="@/assets/logo_monochrome_white.svg"
                    height="1rem"
                    class="ml-2"
                    max-width="100px"
                />
                </a>
            </v-col>
          </v-row>
        </v-footer>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.mdAndUp" class="image-content" style="position: relative;">
        <!-- Position the rings with fixed position -->

        <v-img
          src="@/assets/audiChargingHub.jpg"
          height="100%"
          position="15% 50%"
          style="z-index: 99; position: fixed"
        />

        <v-footer
            color="black"
            dark
            absolute
            width="100%"
            v-if="$vuetify.breakpoint.mdAndUp"
        >
          <v-row
            no-gutters
            class="ma-0"
            justify="end"
            align="center"
          >
            <v-col>
                {{ configStore.version }}
                <a
                href="https://book-n-use.com/"
                target="_blank"
                rel="noopener noreferrer"
                class="d-inline-flex align-center"
                >
                <span style="font-size: 11px">powered by</span>
                <v-img
                    :aspect-ratio="353/71"
                    contain
                    src="@/assets/logo_monochrome_white.svg"
                    height="1rem"
                    class="ml-2"
                    max-width="100px"
                />
                </a>
            </v-col>
            <v-spacer/>
            <v-col cols="12" md="auto" class="ml-6">
                <a
                href="https://www.green-mobility-solutions.de/impressum/"
                target="_blank"
                rel="noopener noreferrer"
                >
                {{ $t('Imprint') }}
                </a>
            </v-col>
            <v-col cols="12" md="auto" class="ml-6">
                <a
                :href="urls.TERMS_OF_SERVICE"
                target="_blank"
                >
                {{ $t('Terms of Service') }}
                </a>
            </v-col>
            <v-col cols="12" md="auto" class="ml-6 mr-3">
                <a
                :href="urls.PRIVACY_POLICY"
                target="_blank"
                >
                {{ $t('Privacy Policy') }}
                </a>
            </v-col>
          </v-row>
        </v-footer>
      </v-col>
    </v-row>
</template>
<style lang="css" scoped>

.v-footer {
  padding: 1.125rem;
  line-height: normal;
}

.v-footer a {
  text-decoration: none;
  line-height: 1.63rem;
  font-size: 1rem;
}

.page-content .v-footer a {
  line-height: 2.375rem;
}

.theme--dark a {
  color: #fff;
}

.theme--dark a:hover {
  color: #b3b3b3;
}

.page-content {
  background-color: #fff;
  box-shadow: 0 .125rem 1.5rem 0 rgba(0, 0, 0, .2);
  min-height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 5000;
}

.page-container .page-content .legal-entity .legal-entity-logo {
    margin: 1.5rem auto 2.5rem;
    height: 4rem;
    width: 4rem;
}

.page-container .page-content .legal-entity {
    display: flex;
    flex-direction: column;
    text-align: center;
}

.legal-entity-name {
    font-family: Heading,sans-serif;
    font-size: 1rem;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #000
}

.page-container .page-content .legal-entity .legal-entity-name {
    align-self: flex-start;
    font-family: Regulartext,sans-serif;
    font-size: 1rem;
    line-height: 1.38rem;
    height: 1.125rem
}

@media screen and (max-width: 34.999rem) {
    .page-container .page-content .title {
        padding-top:0
    }

    .page-container .page-content .content {
        margin: 0 3rem
    }

    .page-container .page-content .content,.page-container .page-content .legal-entity-name {
        margin-left: 18px;
        margin-right: 18px
    }

    .page-container .page-content .legal-entity .legal-entity-logo {
        width: 4.6875rem;
        height: 1.625rem
    }
}

@media screen and (min-width: 35rem)and (max-width: 63.999rem) {
    .page-container .page-content .title {
        padding-top:0
    }

    .page-container .page-content .content,.page-container .page-content .legal-entity {
        margin: 0 auto;
        width: 342px
    }

    .page-container .page-content .legal-entity {
        margin-top: 11.125rem
    }

    .page-container .page-content .legal-entity .legal-entity-logo {
        width: 4.6875rem;
        height: 1.625rem
    }
}

@media screen and (max-width: 64rem) {
    .page-container .page-content {
        width:100vw
    }
}

@media screen and (min-width: 64rem) {
    .page-container .page-content {
        width:33.3333vw
    }

    .page-container .page-content .legal-entity .content {
        padding-top: 178px
    }

    .page-container .page-content .legal-entity .content .title {
        padding-top: 0
    }

    .page-container .page-content .legal-entity .legal-entity-logo {
        position: fixed;
        width: 8.625rem;
        height: 3rem;
        top: 2.125rem;
        right: 1.125rem;
        margin: 0
    }
}

@media screen and (min-width: 64rem)and (max-width: 89.999rem) {
    .page-container .page-content .content,.page-container .page-content .legal-entity {
        margin:0 auto;
        width: 306px
    }

    .page-container .page-content .legal-entity {
        margin-top: 10rem
    }
}

@media screen and (min-width: 90rem) {
    .page-container .page-content .content,.page-container .page-content .legal-entity {
        margin:0 auto;
        width: 420px
    }

    .page-container .page-content .legal-entity {
        margin-top: 10rem
    }
}

@media screen and (min-width: 80rem)and (max-width: 120rem) {
    .legal-entity-logo {
        right:1.875rem
    }

    .body-container footer ul,.body-container .legal-document-footer-bottom ul {
        padding-right: 1.875rem
    }
}

@media screen and (min-width: 120rem) {
    .legal-entity-logo {
        top:4rem;
        right: 3.75rem
    }

    .body-container footer ul,.body-container .legal-document-footer-bottom ul {
        padding-right: 3.75rem
    }
}

@media screen and (max-width: 34.999rem) {
    .legal-entity-logo {
        width: 4.6875rem;
        height: 1.625rem
    }
}

@media screen and (min-width: 35rem)and (max-width: 63.999rem) {
    .legal-entity-logo {
        width: 4.6875rem;
        height: 1.625rem
    }
}

@media screen and (max-width: 64rem) {
    .page-container .page-content {
        width:100vw
    }
}

@media screen and (min-width: 64rem) {
    .legal-entity-logo {
        position: fixed;
        width: 8.625rem;
        height: 3rem;
        top: 2.125rem;
        right: 1.125rem;
        margin: 0
    }
}
</style>
